import { useAppDispatch } from 'store/useAppDispatch';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';
import { waitForLocalStorageSync } from 'modules/common/utils/waitForLocalStorageSync';

import { setRedirectURL } from '../store/authSlice';

export interface UseSignInWithRedirectURLProps {
  hasAPIKeysNotification?: boolean;
  redirectURL: string;
}

export const useSignInWithRedirectURL = ({
  hasAPIKeysNotification,
  redirectURL,
}: UseSignInWithRedirectURLProps) => {
  const { handleSignIn } = useSSOAuth({ hasAPIKeysNotification });

  const dispatch = useAppDispatch();

  const signInWithRedirectURL = async () => {
    dispatch(setRedirectURL(redirectURL));

    await waitForLocalStorageSync();

    handleSignIn();
  };

  return signInWithRedirectURL;
};
